<script setup lang="ts">
import HeaderBackButton from "@/core/components/header-back-button/HeaderBackButton.vue";
import {ref} from "vue";
import {NotificationTemplate as INotificationTemplate} from "@/notification-template/interfaces";
import {useCommunicationStore} from "@/communication/stores/communication.store";
import {useRouter} from "vue-router";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import SMSNotificationTemplateTabs from "@/notification-template/components/sms-tabs/SMSNotificationTemplateTabs.vue";

const {programId, customers} = useCommunicationStore();
const loading = ref(false);
const communicationStore = useCommunicationStore();
const router = useRouter();

/**
 * On message selected.
 *
 * @param template
 */
const onSelected = (template: INotificationTemplate) => {
    communicationStore.template = template;
    router.push({
        name: 'patient-administration.communication.summary'
    });
};

/**
 * On custom content selected.
 *
 * @param content  The content.
 */
const onContentSelected = (content: string) => {
    communicationStore.content = content;
    router.push({
        name: 'patient-administration.communication.summary'
    });
};
</script>

<template>
  <div>
    <HeaderBackButton title="Communication par SMS" />
    <div>
      <BaseFlexSpinner v-if="loading" />
      <div v-else class="bg-white shadow-lg p-4 rounded-lg m-4">
        <SMSNotificationTemplateTabs
          :customer-id="customers[0].id"
          :program-id="programId"
          @template-selected="template => onSelected(template)"
          @custom-content="custom => onContentSelected(custom.content)"
        />
      </div>
    </div>
  </div>
</template>
